<tn-dialog-shell
  testId="job-progress"
  [title]="(title || ('Loading' | translate)) || ''"
  [showCloseButton]="false"
  [hideActions]="!hasAbortButton"
>
  @if (showMinimizeButton) {
    <tn-icon-button
      name="minus"
      library="mdi"
      class="minimize-button"
      testId="close"
      [attr.aria-label]="'Hide Job' | translate: { jobMethod: job.method }"
      (click)="minimize()"
    ></tn-icon-button>
  }
  <div class="job-dialog">
    @if (showRealtimeLogs && realtimeLogs) {
      <div class="logs-container">
        <h5>{{ 'Logs' | translate }}</h5>
        <pre #logs class="message logs" tnTestId="job-logs" tnTestIdType="text">{{ realtimeLogs | translate }}</pre>
      </div>
    }

    @if (isJobRunning) {
      <div>
        <div class="description-line">
          <span tnTestId="job-description" tnTestIdType="text">{{ job.description ? job.description : job.method }}</span>
          @if (!hideProgressValue) {
            <small tnTestId="job-progress-percent" tnTestIdType="text">
              {{ progressTotalPercent || 0 | number: '1.2-2' }}%
            </small>
          }
        </div>
        <tn-progress-bar
          class="job-progress job-running"
          [value]="progressTotalPercent"
          [mode]="progressTotalPercent ? 'determinate' : 'indeterminate'"
          [ariaLabel]="'Progress of {job}' | translate: { job: job.description || job.method }"
        ></tn-progress-bar>
      </div>
    }

    @if (!isJobStateDeterminate) {
      <div>
        <tn-progress-bar
          class="job-progress job-ended"
          [mode]="'indeterminate'"
          [ariaLabel]="'Progress of {job}' | translate: { job: job.description || job.method }"
        ></tn-progress-bar>
      </div>
    }

    @if (description) {
      <div
        class="job-description"
        [innerHTML]="description"
      ></div>
    }

    @if (!description && !job) {
      <div>
        <tn-progress-bar
          mode="indeterminate"
          class="job-progress"
        >
        </tn-progress-bar>
      </div>
    }
  </div>

  <!--
    The footer must be a direct child of tn-dialog-shell: ng-content [select]
    does not project from inside @if blocks, so the conditional lives inside the
    action container. When there is no abort button the shell hides the empty
    footer via [hideActions] (set on tn-dialog-shell above).
  -->
  <div tnDialogAction class="abort-action">
    @if (hasAbortButton) {
      <tn-button
        variant="outline"
        testId="abort"
        [label]="isAbortingJob ? ('Aborting...' | translate) : ('Abort' | translate)"
        [disabled]="isAbortingJob"
        [ariaLabel]="'Abort Job' | translate"
        (onClick)="abortJob()"
      ></tn-button>
    }
  </div>
</tn-dialog-shell>
